import { render } from "./PersonalReservationTable.vue?vue&type=template&id=caaf6610"
import script from "./PersonalReservationTable.vue?vue&type=script&lang=js"
export * from "./PersonalReservationTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__